<div class="page-header">
  <mat-icon [svgIcon]="icon()" class="page-header-breadcrumbs-icon"></mat-icon>
  <div class="page-header-title">{{ title() }}</div>
</div>
